import React, { useState } from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import { Icon } from '@iconify/react';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import MakerManualSettlementTable from '../components/MakerManualSettlementTable';
interface MakerManualSettlementProps {
  onLogout: () => void;
}
export default function MakerManualSettlement({
  onLogout
}: MakerManualSettlementProps) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  return <Box sx={{
    display: 'flex',
    width: '100%',
    minHeight: '100vh',
    backgroundColor: 'background.default',
    overflow: 'hidden'
  }} data-id="element-3895" data-mp="1pbhtarh3dlte">
      
      <TopBar onMenuClick={handleDrawerToggle} onLogout={onLogout} title="Maker - Manual Settlement" data-id="element-3896" data-mp="1gb361mkkhwn9" />
      
      <Sidebar open={mobileOpen} onClose={handleDrawerToggle} activePage="maker-manual-settlement" data-id="element-3897" data-mp="19u0ptezcbalq" />
      
      <Box component="main" sx={{
      flexGrow: 1,
      py: 2,
      px: {
        xs: 2,
        sm: 3,
        md: 5
      },
      width: {
        xs: '100%',
        sm: `calc(100% - 240px)`
      },
      maxWidth: '100%',
      ml: 0,
      mt: 8,
      overflow: 'hidden'
    }} data-id="element-3898" data-mp="14vphx9slva65">
        
        <Box sx={{
        maxWidth: '100%'
      }} data-id="element-3899" data-mp="m6snn5x7khnx">
          
          <Box sx={{
          display: 'flex',
          alignItems: 'center',
          mb: 2
        }} data-id="element-3900" data-mp="zxxno94hnbys">
            
            <Icon icon="lucide:inbox" width={28} height={28} color="#0EA5E9" data-id="element-3901" data-mp="v4cls5zrxxub" />
            <Typography variant="h5" component="h1" sx={{
            ml: 1.5,
            fontWeight: 600
          }} data-id="element-3902" data-mp="7es4rsn6lano">
              
              Maker Inbox - Manual Settlement
            </Typography>
          </Box>
          <MakerManualSettlementTable data-id="element-3903" data-mp="27hjjl1augzq5" />
        </Box>
      </Box>
    </Box>;
}